/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2023 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export function getUnitsData(){

    let data = [];

    $('.js-jobUnits-controls').each(function (){
        data.push({name: $(this).attr('name'), value: $(this).val()});
    });

    let _type = $('.js-job-type:checked').val();
    if( typeof _type != 'undefined' && _type !=  '' && _type !=  null){
        data.push({name: "id_afpw_job_type_value", value: _type});
    }else{
        return false;
    }

    let _manufacturer = $('.js-manufacturer-selection:checked').val();
    if( typeof _manufacturer != 'undefined' && _manufacturer !=  '' && _manufacturer !=  null){
        data.push({name: "id_afpw_job_type_value_brand", value: _manufacturer});
    }else{
        return false;
    }

    if(data.length <= 0){ return ; }

    return data;

}

export function getProductList(){
    window.List = [];
    $('.js-listItem').each(function (){
        if( $(this).attr('data-active') == 1 ){

            const formData = {};
            formData['serialized_data'] = $(this).find('form:first').serialize();
            formData['id_product'] = $(this).attr('data-productid');
            formData['qty'] = $(this).attr('data-productqty');
            formData['slot'] = $(this).attr('data-slot');

            window.List.push(
                formData
            );
        }
    });
}

export function addToProductListById(id){
    if(!id){ return; }

    const formData = {};
    formData['serialized_data'] = $('.js-listItem[data-productid="'+ id +'"]').find('form:first').serialize();
    formData['id_product'] = $('.js-listItem[data-productid="'+ id +'"]').attr('data-productid');
    formData['qty'] = $('.js-listItem[data-productid="'+ id +'"]').attr('data-productqty');
    formData['slot'] = $('.js-listItem[data-productid="'+ id +'"]').attr('data-slot');

    window.List.push(
        formData
    );
}

export function removeFromProductListById(id){

    if(!id){ return; }

    const _temp_arr = [];
    for (let i = 0; i < window.List.length; i++) {
        if( window.List[i].id_product != id ){
            _temp_arr.push(window.List[i]);
        }
    }
    window.List = _temp_arr;
}

export function removeFromProductListBySlot(slot){

    if(!slot){ return; }

    const _temp_arr = [];
    for (let i = 0; i < window.List.length; i++) {
        if( window.List[i].slot != slot ){
            _temp_arr.push(window.List[i]);
        }
    }
    window.List = _temp_arr;
}

export function replaceProductToList(slot, el){
    if(!slot ){ return; }

    removeFromProductListBySlot(slot);

    const formData = {};
    formData['serialized_data'] = el.find('form:first').serialize();
    formData['id_product'] = el.find('.js-tab-product-selection').val();
    formData['qty'] = el.find('.js-tabListProduct-qnt').val();
    formData['slot'] = slot;

    window.List.push(
        formData
    );
}

export function cancelReplaceProductToList(slot){
    if(!slot ){ return; }

    const _defaultId = $('.js-listItem[data-slot="'+ slot +'"]').attr('data-productid');
    const _newId = $('.js-productTabs[data-slot="'+ slot +'"]').find('.js-productTabs-tab.active').find('.js-tab-product-selection:checked').val();

    if( _defaultId != _newId){
        removeFromProductListBySlot(slot);
        addToProductListById(_defaultId);
        $('.js-productTabs[data-slot="'+ slot +'"]').find('.js-productTabs-tab').find('.js-tabListProduct[data-productId="'+ _defaultId +'"]').find('.js-tab-product-selection').prop("checked", true);
    }
}